import React from 'react';

export function useComponentDidMount(callback: () => void | (() => void)) {
  // intentionally disabling it here, since we intentionally only want code to run once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(callback, []);
}
